// = require qs/dist/qs

devex = devex || {};

devex.urls = devex.urls || {};

devex.urls.listeners = {pushState: []};

/**
 * Updates url parameters
 *
 * Multiple nesting levels are supported
 *
 * @param stateObj {Object}      Optional additional data that should be
 *                               stored with the state
 * @param title                  window title that should be stored with the
 *                               state. Defaults to current title
 * @param params {Object|String} the parameters that should be pushed to the
 *                               window location. If params is an object,
 *                               the objects gets serialized and url encoded
 *                               first. Deep nesting is supported in case
 *                               of objects.
 * @returns {string} Serialized version of url parameters
 * @example
 *   devex.urls.pushState(null, document.title, {a:{b:'c'}})
 *   // sets the url parameters to ?a[b]=c
 */
devex.urls.pushState = function (stateObj, title, params) {
  var historyAPI = (history && history.pushState) ? history : History;
  if (typeof params === 'object') {
    params = '?' + $.param(params);
  }
  historyAPI.pushState(stateObj, title || document.title, params);
  devex.urls.listeners.pushState.forEach(function(listener) {
    listener();
  });
  return params;
};

var parsePrimitives = function(obj) {
  var filter = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var value = obj[key];

      if (Array.isArray(value)) {
        value = obj[key].map(function(element) {
          if (/^\d+$/.test(element)) { return JSON.parse(element); }
          return element;
        });
      } else {
        if (value === 'true' || value === 'false' || value === 'null' || /^\d+$/.test(value)) {
          value = JSON.parse(value);
        }
      }
      filter[key] = value;
    }
  }

  return filter;
};

/**
 * Retrieves and deserializes URL parameters.
 *
 * @example
 *   When on 'http://..?a[b]=c&a[d]=e
 * @returns
 *  {
 *    a: {
 *      b: 'c',
 *      d: 'e'
 *    }
 *  }
 */
devex.urls.getParams = function () {
  // These 3 lines of code below could probably be safely removed. We probably could call Qs.parse
  // directly without assigning it to $.deparam. The code is working as is though, so we
  // don't want to embark on refactoring it right now. The goal is to remove all code that
  // load devex.urls global variable in favor of ES6 modules. We are nearly there.
  if (typeof Qs !== 'undefined') {
    $.deparam = Qs.parse;
  }

  // As seen above in the code, $.deparam actually corresponds to Qs.parse.
  // The default arrayLimit param is 20. We intentionally set this arrayLimit to 300.
  // In practice, this means that, for all the searches that use SearchJS and therefore
  // devex.urls.getParams to parse the URL params, we can have up to 300 filter values
  // for a given filter key.
  var paramsObj = $.deparam(window.location.search.substring(1), {arrayLimit: 300});

  if (!paramsObj.filter && !paramsObj.filters) { return paramsObj; }

  if (paramsObj.filter) { paramsObj.filter = parsePrimitives(paramsObj.filter); }

  if (paramsObj.filters) { paramsObj.filters = parsePrimitives(paramsObj.filters); }

  return paramsObj;
};

/**
 * Allows to bind a callback to the event of pushState url changes
 *
 * @param event {String}
 *  - 'popState': when url changes
 *  - 'popState': when navigating back in history (back-button)
 * @param callback {Function}
 *  pointer to callback function that gets invoked when the event occurs.
 */
devex.urls.on = function(event, callback) {
  // writing history
  if (event === 'pushState' || event === 'stateChange') {
    devex.urls.listeners.pushState.push(callback);
  }
  // moving back in history
  if (event === 'popState' || event === 'stateChange') {
    $(window).on('popstate', function (e) {
      callback(e);
    });
  }
};

/**
 * Wrapper for `window.location` so that it can be stubbed in tests
 *
 * @returns {* | Location | string}
 */
devex.urls.getLocation = function() {
  return window.location;
};

/**
 * Returns either baseUrl?#{paramKey}=#{paramValue} or
 * baseUrl?foo=bar&#{paramKey}=#{paramValue}, based on the base URL parameters
 *
 * @param baseUrl {String} The base URL, with or without encoded params
 * @param params {Object} The params to be added to the baseUrl as an object.
 * Object has to be compliant with the jQuery.param() method
 * http://api.jquery.com/jquery.param/
 *
 *
 * @returns {string} Returns the baseUrl, concatenated with the encoded
 * params
 */

//
devex.urls.concatParamsToUrl = function(baseUrl, params) {
  var baseUrlWithOperator =
    baseUrl.indexOf('?') > -1 ? baseUrl.concat('&') : baseUrl.concat('?');
  return baseUrlWithOperator.concat($.param(params));
};
